export const gqlObject = <T = unknown>(object: T) => ({
  variables: { object },
});
